import { IdNomeDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { FiltroSituacaoClinicaDTO, FiltroTerapiaParmDTO, FiltroTerapiaSimplParmDTO, TerapiaDetalheDTO, TerapiaListItemDTO, TerapiaParmDTO, TerapiaSimplificadaParmDTO, UnidadeAcessoProdutosResult, UnidadesAcessosProdutosParmDTO } from '@/interfaces/therapy';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function getTherapies(filtros: FiltroTerapiaParmDTO): Observable<ResultPagDTO<TerapiaListItemDTO>> {
  return from(apiClient.get(ENDPOINTS.THERAPY, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getTherapyVolumeUnits(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.THERAPY_VOLUME_UNITS}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getTherapy(id: Number): Observable<TerapiaDetalheDTO> {
  return from(apiClient.get(`${ENDPOINTS.THERAPY}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getInitTherapy(): Observable<TerapiaDetalheDTO> {
  return from(apiClient.get(ENDPOINTS.THERAPY_INIT)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function saveTherapy(therapy: TerapiaParmDTO): Observable<Number> {
  if (therapy.idTerapia != null) {
    return updateTherapy(therapy);
  }
  return from(apiClient.post(ENDPOINTS.THERAPY, therapy)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function updateTherapy(therapy: TerapiaParmDTO): Observable<Number> {
  return from(apiClient.put(ENDPOINTS.THERAPY, therapy)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listNPTs(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_NPTS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listClinicSituations(filters: FiltroSituacaoClinicaDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_CLINICS_SITUATIONS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listProductsSimpleTherapy(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_PRODUCTS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}


export function listClientsAvailableSimpleTherapy(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_CLIENTS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listTnDaysSimpleTherapy(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_TN_DAYS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listNutritionOffers(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_NUTRITION_OFFERS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listActiveTherapies(idNotInclude: number): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY_ACTIVE_THERAPIES, { idDesconsiderar: idNotInclude })).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function saveOrUpdate(parm: TerapiaSimplificadaParmDTO): Observable<number> {
  if (parm.id != null) {
    return update(parm);
  }
  return from(apiClient.post(ENDPOINTS.SIMPLE_THERAPY, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

function update(parm: TerapiaSimplificadaParmDTO): Observable<number> {
  return from(apiClient.put(ENDPOINTS.SIMPLE_THERAPY, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function listSimpleTherapies(filtros: FiltroTerapiaSimplParmDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.SIMPLE_THERAPY, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function findSimpleTherapyById(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SIMPLE_THERAPY}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function validUnitsClientsProductsAvailable(parm: UnidadesAcessosProdutosParmDTO): Observable<UnidadeAcessoProdutosResult[]> {
  return from(apiClient.post(ENDPOINTS.SIMPLE_THERAPY_VALID_UNITCLIENT_PROD, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}



